module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "meteengdate"
  }, [_c('h3', {
    staticClass: "meteengdate__date"
  }, [_vm._v(_vm._s(_vm.date.day))]), _c('p', {
    staticClass: "meteengdate__month"
  }, [_vm._v(_vm._s(_vm.date.month))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e33e0fd","hasScoped":true,"preserveWhitespace":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/profile/modules/mentoring/modal/components/meeting/components/date/MentoringMeetingDate.vue
// module id = 028db9f8b0546087adc8
// module chunks = 89